import React from 'react';
import BEM from '../bem';
import { ReactComponent as TigerAgentIcon } from '../images/tiger-agent-icon.svg';
import { actions, useAppDispatch, useAppSelector } from 'redux-stores';

const { setTigerAgentPaneOpen } = actions;

const classes = BEM.with('TigerAgentButton');

export default function TigerAgentButton() {
  const dispatch = useAppDispatch();
  const tigerAgentPaneOpen = useAppSelector((state) => state.ui.tigerAgentPaneOpen);

  return (
    <button
      className={classes()}
      data-test-id="tiger-agent-button"
      onClick={() => dispatch(setTigerAgentPaneOpen(!tigerAgentPaneOpen))}
      type="button"
    >
      <TigerAgentIcon aria-hidden className={classes('icon')} />
      <span>Tiger Agent</span>
    </button>
  );
}
